
/**
 * @param {String} name The name of the property to read from this document's cookies
 * @return {?String} The specified cookie property's value (or null if it has not been set)
 */
export const read = (name) => {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }

  return null;
};

/**
 * @param {String} name The name of the property to set by writing to a cookie
 * @param {String} value The value to use when setting the specified property
 * @param {number} [days] The number of days until the storage of this item expires
 */
export const write = (name, value, days) => {
  const expiration = (function getExpiration() {
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      return '; expires=' + date.toGMTString();
    } else {
      return '';
    }
  })();

  document.cookie = name + '=' + value + expiration + '; path=/';
};

export const clear = () => {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const equals = cookies[i].indexOf('=');
    const name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
  }
};
